import { ServerMessagesMapping } from '@core-models/messages/server-messages-mapping';

export const serverMessagesMapping: ServerMessagesMapping = {
    Auth_User_NotFound: {
        code: 400,
        messageTranslationPath: 'LOGIN.ERRORS.SERVER.WRONG_CREDENTIALS',
        title: ''
    }
};